import { LocaleTextHook } from '@moonpig/web-core-locale-text'
import { NAV_TEXT } from '../../locale'
import { DepartmentType } from '../departmentMap'
import { Reminder } from '../Reminders/Reminder'
import { InspirationType, RecentSearchType, SearchRow } from '../types'
import {
  buildInspirationsSection,
  buildRecentSearchesSection,
  buildRemindersSection,
} from './buildFocusableSections'

export const buildFocusableSection = ({
  activeDepartment,
  recentSearches,
  inspirations,
  reminders,
  localiseText,
  startIndex,
}: {
  activeDepartment: DepartmentType
  recentSearches: RecentSearchType[]
  inspirations: InspirationType[]
  reminders: Reminder[]
  localiseText: LocaleTextHook<typeof NAV_TEXT>
  startIndex: number
}) => {
  const index = startIndex
  const staticRowIndex = 0
  const focusableRows: SearchRow[] = []
  const focusableSectionId = 'focusable'

  const recentsSection = buildRecentSearchesSection({
    focusableSectionId,
    focusableRows,
    activeDepartment,
    recentSearches,
    startIndex: index,
    staticRowIndex,
    localiseText,
  })

  const remindersSection = buildRemindersSection({
    focusableSectionId,
    focusableRows,
    reminders,
    startIndex: recentsSection.index,
    staticRowIndex: recentsSection.staticRowIndex,
    localiseText,
  })

  buildInspirationsSection({
    focusableSectionId,
    focusableRows,
    activeDepartment,
    inspirations,
    startIndex: remindersSection.index,
    staticRowIndex: remindersSection.staticRowIndex,
    localiseText,
  })

  return focusableRows
}
